import { button } from './button';
import { content, errorPage } from './layout';
import { modal } from './modal';
import { tableScrollWrapButton, theadButton } from './table';

export const cssOverrides = { button, content, errorPage, modal, tableScrollWrapButton, theadButton };
